import { render, staticRenderFns } from "./PEP.vue?vue&type=template&id=20f40772&scoped=true&"
import script from "./PEP.vue?vue&type=script&lang=js&"
export * from "./PEP.vue?vue&type=script&lang=js&"
import style0 from "./PEP.vue?vue&type=style&index=0&id=20f40772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f40772",
  null
  
)

export default component.exports